import { render, staticRenderFns } from "./SettingsDesign.vue?vue&type=template&id=3669d6c8&scoped=true"
import script from "./SettingsDesign.vue?vue&type=script&lang=js"
export * from "./SettingsDesign.vue?vue&type=script&lang=js"
import style0 from "./SettingsDesign.vue?vue&type=style&index=0&id=3669d6c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3669d6c8",
  null
  
)

export default component.exports